import { Box, Typography } from "@mui/material";
import convertToPoints from "@/utils/convertToPoints";

interface PriceDisplayProps {
  amount: number;
  quantity: number;
  variant?: "mobile" | "desktop";
}

export const PriceDisplay = ({
  amount,
  quantity,
  variant = "mobile",
}: PriceDisplayProps) => {
  const fontSize = variant === "mobile" ? 24 : 28;
  const totalPoints = Math.round(convertToPoints(amount) * quantity);
  const unitPoints = convertToPoints(amount);

  return (
    <Box sx={{ flex: 1, textAlign: "right" }}>
      <Typography
        variant="body2"
        sx={{
          fontSize: 11,
          fontWeight: 600,
          color: "text.secondary",
          mb: 0.5,
          textTransform: "uppercase",
          letterSpacing: 0.3,
        }}
      >
        Total Price
      </Typography>
      <Typography
        sx={{
          fontSize,
          fontWeight: 800,
          color: "primary.main",
          lineHeight: 1.2,
        }}
      >
        {totalPoints} Points
      </Typography>
      {quantity > 1 && (
        <Typography
          variant="caption"
          sx={{
            fontSize: 11,
            color: "text.secondary",
            fontWeight: 500,
          }}
        >
          {unitPoints} × {quantity}
        </Typography>
      )}
    </Box>
  );
};
